<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import BannerCarousalCard from './BannerCarousalCard.svelte';

  export let data;
  const { encodedContextPath = 'en-sa' } = getAppConfig();
</script>

<a href={`${encodedContextPath}${data?.redirectionUrl}`} class="link">
  <BannerCarousalCard {data} />
</a>

<style>
  a.link {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
</style>
